import authImg from 'assets/img/auth/auth0.png';
import Footer from 'components/footer/FooterAuthDefault';
function Default(props: { maincard: JSX.Element }) {
  const { maincard } = props;
  return (
    <div className="relative flex h-screen overflow-hidden">
      <div className="mx-auto flex h-full w-full flex-col justify-between md:max-w-[75%] lg:max-w-[1013px] lg:px-8 xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
        <div className="flex flex-col items-center justify-center flex-1 pl-5 pr-5 md:pr-0 md:pl-12 lg:max-w-[48%] lg:pl-0 xl:max-w-full">
          {maincard}
        </div>
        <Footer />
        <div className="absolute right-0 hidden h-full md:block lg:w-[49vw] 2xl:w-[44vw]">
          <div 
            className="absolute flex h-full w-full items-end justify-center bg-cover bg-center lg:rounded-bl-[120px] xl:rounded-bl-[200px] bg-gradient-to-br from-brand-400 to-brand-600"
          >
            <div className="relative h-full w-full flex items-center justify-center">
              <div                      
                style={{ backgroundImage: `url(${authImg})` }}                      
                className="h-2/3 w-2/3 flex bg-cover bg-center"              
              />                  
            </div>
          </div>     
        </div>
      </div>
    </div>
  );
}

export default Default;
